import BreadcrumbLink from "components/elements/Breadcrumbs/BreadcrumbLink";
import {
  isModelPageType,
  modelPageTypes,
} from "lib/types/assets/ModelPageType";
import { UrlObject } from "url";

export default function BreadcrumbAssetPageType(p: {
  params: string[];
  href: UrlObject;
}) {
  const assetPageType = p.params[0];
  const text = isModelPageType(assetPageType)
    ? modelPageTypes[assetPageType].label
    : assetPageType[0]?.toUpperCase() + assetPageType.slice(1);
  return <BreadcrumbLink href={p.href}>{text}</BreadcrumbLink>;
}
